import React, { FC, HTMLAttributes } from 'react';

import { alpha, BoxProps, styled, Theme } from '@material-ui/core';
import { Box } from '@material-ui/core';

const StyledBlankInput = styled(Box)<Theme>(({ theme }) => ({
  border: 'none',
  flex: 1,
  padding: theme.spacing(1),
  backgroundImage: 'none',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  fontFamily: theme.typography.body1.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.body1.fontWeight,
  lineHeight: theme.typography.body1.lineHeight,
  '&::placeholder': {
    fontStyle: 'italic',
  },
  '&:focus': {
    boxShadow: `2px 2px 2px  ${alpha('#B6B0A3', 1)}`,
    fontWeight: 400,
  },
  '&:focus-visible': {
    outline: 'none',
  },
  '&.ellipsis': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));

export type BlankInputProps = HTMLAttributes<HTMLInputElement> &
  BoxProps & {
    ellipsis?: boolean;
    onReturnKey?: (value: string) => void;
    [key: string]: any;
  };

const BlankInput: FC<BlankInputProps> = ({ ellipsis, className = '', onReturnKey, ...other }) => {
  const handleKeyDown = (event: any) => {
    if (onReturnKey && event.keyCode === 13) {
      event.target.blur();
      onReturnKey(event.target.value);
    }
  };

  return (
    <StyledBlankInput
      component="input"
      className={`${ellipsis && 'ellipsis'} ${className}`}
      onKeyDown={handleKeyDown}
      {...other}
    />
  );
};

export default BlankInput;
